import { objectSchemaOf, Joi, actionCreator } from '../helpers';

export const UNSUBSCRIBE = 'CHANNELS/UNSUBSCRIBE';

export const unsubscribeActionSchema = objectSchemaOf<IUnsubscribeAction>({
  type: Joi.string().required().valid(UNSUBSCRIBE),
  payload: objectSchemaOf<IUnsubscribeAction['payload']>({
    channels: Joi.array().items(Joi.string()).min(1).required(),
  }),
});

export interface IUnsubscribeAction {
  type: typeof UNSUBSCRIBE;
  payload: {
    channels: string[];
  };
}

export const unsubscribe = actionCreator({
  type: UNSUBSCRIBE,
  schema: unsubscribeActionSchema,
  creator: (channels: string[]): IUnsubscribeAction => ({
    type: UNSUBSCRIBE,
    payload: {
      channels,
    },
  }),
});
